export default __webpack_public_path__ + "static/media/tut2novoville.5c5f31b3.png";